import { AppColors } from "@/styles/colors";
import { Button, Flex, Text } from "@chakra-ui/react";
import { Check, CircleCheckBig, X } from "lucide-react";

interface Props {
  loadingAssign: boolean;
  loadingDone: boolean;
  loadingClose: boolean;
  loadingReject: boolean;
  onAssign: () => void;
  onDone: () => void;
  onClose: () => void;
  onReject: () => void;
  showAssign: boolean;
  showDone: boolean;
  showClose: boolean;
  showReject: boolean;
}

export const FieldVisitDetailActions = ({
  loadingAssign,
  loadingDone,
  loadingClose,
  loadingReject,
  onAssign,
  onDone,
  onClose,
  onReject,
  showAssign,
  showDone,
  showClose,
  showReject,
}: Props) => {
  const disabled = loadingAssign || loadingDone || loadingClose || loadingReject;

  return (
    <Flex gap="12px">
      {showAssign && (
        <Button
          paddingX="12px"
          height="32px"
          bgColor={AppColors.GREEN_PRIMARY}
          onClick={onAssign}
          disabled={disabled}
        >
          <Check />
          <Text fontWeight={600} fontSize="14px">
            Asignar
          </Text>
        </Button>
      )}

      {showDone && (
        <Button
          paddingX="12px"
          height="32px"
          bgColor={AppColors.GREEN_PRIMARY}
          onClick={onDone}
          disabled={disabled}
        >
          <Check />
          <Text fontWeight={600} fontSize="14px">
            Marcar como realizada
          </Text>
        </Button>
      )}

      {showClose && (
        <Button
          paddingX="12px"
          height="32px"
          bgColor={AppColors.BLACK_TEXT_SECONDARY}
          onClick={onClose}
          disabled={disabled}
        >
          <CircleCheckBig />
          <Text fontWeight={600} fontSize="14px">
            Cerrar visita
          </Text>
        </Button>
      )}

      {showReject && (
        <Button
          paddingX="12px"
          height="32px"
          bgColor={AppColors.RED_ICON}
          onClick={onReject}
          disabled={disabled}
        >
          <X />
          <Text fontWeight={600} fontSize="14px">
            Rechazar
          </Text>
        </Button>
      )}
    </Flex>
  );
};
